import React, { ReactElement, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import React360Viewer from './exterior-360-viewer';
import { carHotSpotPositionsSet, getIsFullscreen } from '../../store/car-slice';
import { useWindowSize } from '../../hooks/use-window-size';
import { useMediaQuery } from '@mui/material';

type Props = {
  onFullscreenClick?: any;
  mList?: ReactElement;
};

export default function Exterior360(props: Props) {
  const { onFullscreenClick, mList } = props;

  const isFullscreen = useSelector(getIsFullscreen);
  const isPortrait = useMediaQuery('(orientation: portrait)');

  // Hook
  const { width, height } = useWindowSize();
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('lg'));
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(carHotSpotPositionsSet([]));
    };
  }, []);

  const handleWidth = useMemo(
    () => width,
    [isFullscreen, isPortrait, width, height],
  );

  return (
    <React360Viewer
      autoplay={false}
      height={height}
      isMobile={isMobile}
      isPortrait={isPortrait}
      mList={mList}
      onFullscreenClick={onFullscreenClick}
      spinReverse={false}
      width={handleWidth}
    />
  );
}
